module.exports = __webpack_public_path__ + "static/media/arrow-down-s-line.afc79cfc.svg";